import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ExceptionsService } from '../../../services/http/exceptions/exceptions.service';
import { Exception } from '../../../services/http/exceptions/exceptions.interface';
import { FormsModule } from '@angular/forms';
import { VehicleType, VehicleTypeResponse } from '../../../services/http/vehicles/vehicles.interface';
import { VehiclesService } from '../../../services/http/vehicles/vehicles.service';
import { Attachment } from '../../../services/http/attachments/attachments.interface';
import { AttachmentUtil } from '../../../services/utils/attachment.utils';
import { AttachmentsService } from '../../../services/http/attachments/attachments.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { DialogService } from '../../../services/dialog/dialog.service';
import { CustomInputFileComponent } from '../../../components/custom-input-file/custom-input-file.component';
import { StatusTagComponent } from '../../../components/status-tag/status-tag.component';
import { DownloadFileService } from '../../../services/downloadFile/download-file.service';

@Component({
  selector: 'app-exceptions-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, CustomInputFileComponent, StatusTagComponent],
  templateUrl: './exceptions-detail.component.html',
  styleUrl: './exceptions-detail.component.scss'
})
export class ExceptionsDetailComponent {
  id = '';
  vehiclePlate = '';
  exception: Exception | null = null;
  vehiclesTypes: any[] = [];
  newFiles = [];
  showFileInput = true;
  observation = '';

  constructor(
    private readonly activeRoute: ActivatedRoute,
    private readonly exceptionsService: ExceptionsService,
    private readonly router: Router,
    private readonly vehiclesService: VehiclesService,
    private readonly attachmentsService: AttachmentsService,
    private readonly loaderService: LoaderService,
    private readonly dialogService: DialogService,
    private readonly downloadFileService: DownloadFileService
  ) {
    this.id = this.activeRoute.snapshot.paramMap.get('id') || '';
    this.vehiclePlate = this.activeRoute.snapshot.paramMap.get('plate') || '';
    if (this.id !== '' && this.vehiclePlate !== '') {
      this.loaderService.show();
      this.exceptionsService.getException(this.id, this.vehiclePlate).subscribe((exception) => {
        this.exception = exception;
        this.loaderService.hide();
      });
    }
    this.vehiclesService.getVehicleTypes().subscribe((data: VehicleTypeResponse) => {
      this.vehiclesTypes = data.registrations;
    });
  }

  async addFiles(fileEvent: any) {
    if (fileEvent && this.exception) {
      const MAX_SIZE = 5 * 1024 * 1024; // 5MB en bytes
      if (fileEvent.size > MAX_SIZE) {
        alert($localize`:@@Exceptions.Create:El archivo supera el tamaño máximo permitido de 5MB`);
        return;
      }
      // check if attachments has a item with the same name
      if (this.exception.attachments.some((attachment) => attachment?.name === fileEvent.name)) {
        alert($localize`:@@Common.FileExist:Ya existe un archivo con el mismo nombre`);
        // reset show of inpit
        this.showFileInput = false;
        setTimeout(() => {
          this.showFileInput = true;
        }, 100);
        return;
      }
      const attachments = Array.from([fileEvent]).map(async (file: File) => {
        return {
          name: file.name,
          description: '',
          mime: file.type,
          data: await AttachmentUtil.arrayBufferToString(file.arrayBuffer())
        } as Attachment
      });
      this.exception.attachments = this.exception.attachments.concat(await Promise.all(attachments));
    }
  }

  sendObservation() {
    if (this.observation && this.exception) {
      this.loaderService.show();
      this.exceptionsService.updateException(this.exception.exceptionIdentifier, this.vehiclePlate, {
        type: this.exception.type,
        municipality: this.exception.municipality,
        municipalities: this.exception.municipalities,
        observations: this.observation
      }).subscribe((success: Exception) => {
        this.exception = success;
        this.loaderService.hide();
        this.router.navigate(['vehicles', this.vehiclePlate]);
      });
    }
  }

  downloadFile(file: Attachment) {
    if (file) {
      //window.open(AttachmentUtil.getDirectLink(this.exception?.applicantIdentifier!, this.exception?.vehiclePlate!, this.exception?.exceptionIdentifier!, fileId));
      this.downloadFileService.getFileNewWindow(AttachmentUtil.getDirectLink(this.exception?.applicantIdentifier!, this.exception?.vehiclePlate!, this.exception?.exceptionIdentifier!, file.uuid!), file.name);
    }
  }

  abrirArchivoBase64EnNuevaPestana(base64String: string, nombreArchivo: string, tipoMIME: string) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: tipoMIME });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  removeFile(fileId: string | undefined) {
    this.dialogService.setDialog({
      title: $localize`:@@Exceptions.Edit.DeleteFile:Eliminar archivo`,
      message: $localize`:@@Exceptions.Edit.DeleteFileMessage:¿Está seguro que desea eliminar el archivo?`,
      button1Text: $localize`:@@Shared.Cancel:Cancelar`,
      button2Text: $localize`:@@Shared.Delete:Eliminar`,
      button1Callback: () => {
        this.dialogService.clearDialog();
      },
      button2Callback: () => {
        if (fileId) {
          this.loaderService.show();
          this.attachmentsService.deleteExceptionAttachment(this.exception?.applicantIdentifier!, this.exception?.vehiclePlate!, this.exception?.exceptionIdentifier!, fileId).subscribe((success: string) => {
            this.loaderService.hide();
            if (this.exception) {
              this.exception.attachments = this.exception?.attachments?.filter((attachment: Attachment) => attachment.uuid !== fileId) || [];
            }
            this.dialogService.clearDialog();
          });
        }
      }
    });
  }

  goBack() {
    this.router.navigate(['vehicles', this.vehiclePlate]);
  }

}
